import React, {useEffect, useState} from "react"
import {
    Automation,
    retrieveAutomations
} from "../../api/AutomationsApi";
import Spinner from "../../ui/Spinner";
import Header from "../../ui/Header";
import {Button} from "../../components/Button";
import AutomationsTable from "./AutomationsTable";
import {AutomationDesigner, Rule} from "./AutomationDesigner";

interface AttributeFilter {
    attributeName: string;
    values: string[];
}

interface AutomationsProps {
}

const Automations: React.FC<AutomationsProps> = (props) => {

    // Loading state
    const [loading, setLoading] = useState(true);

    // Data state
    const [automations, setAutomations] = useState<Automation[]>([]);
    const [filteredAutomations, setFilteredAutomations] = useState<Automation[]>([]);

    // Selection state
    const [selections, setSelections] = useState<{ [automationId: string]: boolean }>({});

    // Modal states
    const [createAutomationModalOpen, setCreateAutomationModalOpen] = useState(false);

    // Filter state
    const [attributeFilters, setAttributeFilters] = useState<AttributeFilter[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>('');

    const [isEditing, setIsEditing] = useState(false);
    const [savedRules, setSavedRules] = useState<Rule[]>([]);

    useEffect(() => {
        document.title = 'Automationen';
        loadAutomations();
    }, []);

    const loadAutomations = async () => {
        try {
            setLoading(true);
            const data = await retrieveAutomations();
            setAutomations(data);
            setFilteredAutomations(data);

            // Initialize selections
            const newSelections: { [automationId: string]: boolean } = {};
            data.forEach(automation => {
                newSelections[automation.id] = false;
            });
            setSelections(newSelections);
        } catch (error) {
            console.error('Failed to load automations:', error);
        } finally {
            setLoading(false);
        }
    };

    // Filter automations based on search query and filters
    useEffect(() => {
        let filtered = automations;

        // Apply search filter
        if (searchQuery) {
            const query = searchQuery.toLowerCase();
            filtered = filtered.filter(automation =>
                automation.name?.toLowerCase().includes(query) ||
                automation.description?.toLowerCase().includes(query) ||
                automation.id.toLowerCase().includes(query)
            );
        }

        // Apply attribute filters if needed
        // This would need to be implemented based on your specific filter requirements

        setFilteredAutomations(filtered);
    }, [automations, searchQuery, attributeFilters]);

    const handleSave = (rule: Rule) => {
        const ruleWithId = { ...rule, id: Date.now().toString() };
        setSavedRules(prev => [...prev, ruleWithId]);
        setIsEditing(false);
        alert('Regel erfolgreich gespeichert!');
    };

    const handleCancel = () => {
        setIsEditing(false);
    };

    // Modal dialog handlers
    const openCreateAutomationModal = () => setCreateAutomationModalOpen(true);

    if (loading) {
        return <Spinner />;
    }

    return (
        <React.Fragment>
            <Header title='Automatisierungen' subtitle={`${filteredAutomations.length} Automatisierungen`}>
                <Button onClick={openCreateAutomationModal} variant="contained" color="primary">
                    Automation erstellen
                </Button>
            </Header>

            <AutomationsTable automations={filteredAutomations} />

            {/*<AutomationDesigner onSave={handleSave} onCancel={handleCancel} />*/}

            {/* Add modals here for creating/editing automations if needed */}
        </React.Fragment>
    );
}

export default Automations;